// extracted by mini-css-extract-plugin
export var bold = "_yl-0";